import { Button } from 'palette/Button';
import { BEMBlock } from '@helpers/classnames';
import '../styles/GlobalSearchRow.scss';

interface GlobalSearchRowProps {
    children: React.ReactNode;
    href: string;
    onClick?: () => void;
}

function GlobalSearchRow({
    children, href, onClick,
}: GlobalSearchRowProps) {
    const [block, BEMElement] = BEMBlock('global-search-row');

    return (
        <a
            className={block}
            href={href}
            tabIndex={0}
        >
            {children}
            <Button
                isTransparent
                className={BEMElement('button')}
                tabIndex={-1}
                theme="secondary"
                onClick={onClick}
            />
        </a>
    );
}

export default GlobalSearchRow;
